const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/gp-user-staging' : 'api/gp-user'
const urls = {
  // 获取全部部门
  getAllDepartment: 'get /api/upc/dept',
  // 通过工号获取所在部门
  getUserDep: 'get /api/upc/user',
  //  搜索播主
  searchUser: 'get /api/inner/user/searchUser',
  // 获取线索列表
  getClueList: 'get /api/tg/keyInfo/:tgId',
  // 保存备注
  saveRemark: 'put /api/tg/keyInfo/:id/remark/',
  // 获取电话列表
  getPhoneList: 'get /api/wk/phone',
  // 拨打电话
  callPhone: 'post /api/wk/phone',

  /*
  * 关联进页面群组
  *   groupIds (关联群组)
  *   userId
  * */
  addMemberToGroup: 'get /api/inner/user/addMemberToGroup',
  // 中心授权记录
  addAuthCenterUserInfo:'post /api/service/addAuthCenterUserInfo',
  // 检测是否授权
  queryAuthCenterUserInfo: 'get /api/service/queryAuthCenterUserInfo' 
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS
